'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import PopUp from '@components/alert/popup'
import { Strings } from '@/lib/constants/strings'
import { useNavigation } from '@/lib/context/navigationcontext'
import { analyticsTags } from '@/app/lib/analytics/analyticsEventTags'
import { pushToDataLayer } from '@/app/lib/analytics/analyticsTracking'

interface LogoutPopupProps {
	isOpen: boolean
	onClose: () => void
	analyticsEventName: string
	from: string
}

export default function LogoutPopup({
	isOpen,
	onClose,
	analyticsEventName,
	from = 'leftNav',
}: Readonly<LogoutPopupProps>) {
	const router = useRouter()
	const { setSelectedNavItem, selectedNavItemBeforeSignout } = useNavigation()

	const {
		POPUP_SIGNOUT_BUTTON,
		POPUP_CANCEL_BUTTON,
		CONFIRM_SIGNOUT_MESSAGE,
		CONFIRM_SIGNOUT_TITLE,
	} = Strings

	const {
		biLogoutConfirmationFromLogoutPopup,
		biLogoutCancelledFromLogoutPopup,
	} = analyticsTags

	const handleCancel = () => {
		pushToDataLayer({
			event: analyticsEventName,
			click_logout: biLogoutCancelledFromLogoutPopup.click_logout,
		})
		onClose()
		if (from === 'leftNav') {
			setSelectedNavItem(selectedNavItemBeforeSignout)
		}
	}

	const handleSignout = () => {
		pushToDataLayer({
			event: analyticsEventName,
			click_logout: biLogoutConfirmationFromLogoutPopup.click_logout,
		})
		onClose()
		router.push('/auth/signout')
	}

	const handlePopupClose = () => {
		onClose()
		if (from === 'leftNav') {
			setSelectedNavItem(selectedNavItemBeforeSignout)
		}
	}

	return (
		<PopUp
			title={CONFIRM_SIGNOUT_TITLE}
			message={CONFIRM_SIGNOUT_MESSAGE}
			actions={[
				{
					text: POPUP_CANCEL_BUTTON,
					variant: 'bespoke',
					color: 'secondary',
					onClick: handleCancel,
				},
				{
					text: POPUP_SIGNOUT_BUTTON,
					variant: 'bespoke',
					color: 'primary',
					onClick: handleSignout,
				},
			]}
			isOpen={isOpen}
			onClose={handlePopupClose}
		/>
	)
}
